var whatsNew = (function () {
  var docElem = window.document.documentElement;
  var block = document.querySelector('.blocked');
  var docElemH = docElem['clientHeight'];
  var animInProgress = false;
  var blocksArr = Array.prototype.slice.call(block.querySelectorAll('.row'));

  function triggerSlides(calledOnLoad) {
    blocksArr.forEach(function (row) {
      var activeRow = row.querySelector('.screenshot-slide');
      if (!activeRow.classList.contains('active')) {
        var rowHeight = row.clientHeight;
        var allowedOffview = rowHeight * .3;
        /* 30 percent of will still trigger slide */
        var rowBottom = row.getBoundingClientRect().bottom,
          rowTop = row.getBoundingClientRect().top,
          bottom = Math.ceil((rowBottom / docElemH) * 100),
          top = Math.ceil((rowTop / docElemH) * 100);
        if (isFullyOnView() || isTopMostlyOnView() || isBottomMostlyOnView()) {

          if (calledOnLoad == 'onload') {
            var isInProgress = setInterval(function () {
              if (!animInProgress) {
                activeRow.addEventListener('animationend', function () {
                  console.log('animation end');
                  animInProgress = false;
                })
                activeRow.classList.add('active');
                textAnimations(row, '.fade-up');
                animInProgress = true;
                clearInterval(isInProgress);
              }
            }, 30);
          } else {
            activeRow.classList.add('active');
            textAnimations(row, '.fade-up');
          }
        }
      }
      function isFullyOnView() {
        if ((bottom < 100 && bottom > -1) && (top < 100 && top > -1)) {
          return true;
        }
      }

      function isTopMostlyOnView() {
        if ((top < 100 && top > -1) && rowBottom - docElemH < allowedOffview) {
          return true;
        }
      }

      function isBottomMostlyOnView() {
        if ((bottom < 100 && bottom > 0) && Math.abs(rowTop) < allowedOffview) {
          return true;
        }
      }
    });
  }

  function init() {
    var intro = document.querySelector('.intro');

    if (window.Promise) {
      var promise = new Promise(function (resolve, reject) {
        intro.addEventListener('animationend', function () {
          resolve();
        });
        textAnimations(intro, '.fade-up');
      })

      promise.then(function () {
        triggerSlides('onload');
      })
    } else {
      intro.addEventListener('animationend', function () {
        triggerSlides('onload');
      });
      textAnimations(intro, '.fade-up');
    }


    window.addEventListener('scroll', triggerSlides, false);
    window.addEventListener('scroll', triggerFadeUpAnimation, false);
    window.addEventListener('scroll', triggerOnebyOneAnim, false);
  }

  return {
    init: init
  }
}())
